module.exports = __webpack_public_path__ + "static/media/shade.67f81056.jpg";